/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/secret';
import { SECRET } from '@/store/types';
import { SecretPost } from '@/api/types/secret';

export interface StoreSecretLuckyState {
  lucky: SecretPost;
}

export default {
  namespaced: true,
  state: {
    lucky: {},
  },
  actions: {
    [SECRET.GET_LUCKY]({ commit }, params) {
      return new Promise((resolve, reject) => {
        api.getLucky(params.body).then((res) => {
          commit(SECRET.GET_LUCKY, res.data);
          resolve();
        }).catch(reject);
      });
    },
  },
  mutations: {
    [SECRET.GET_LUCKY](state, lucky) {
      state.lucky = lucky;
    },
  },
};
